import { Navigate, useParams } from 'react-router-dom';

// 86d3k9589: the legacy /quotations/compose/:draftId page was retired — the workspace is
// now the sole edit/post surface. This preserves old bookmarks and links by redirecting to
// the workspace with intent intact: a numeric draft id opens that draft (?id=), and the
// "new" marker opens a blank draft (?new=1, consumed once by QuotationWorkspacePage).
// `replace` so the dead compose URL doesn't linger in the back-button history.
export function ComposeRedirect() {
  const { draftId } = useParams<{ draftId: string }>();
  const target =
    draftId === 'new'
      ? '/quotations/workspace?new=1'
      : `/quotations/workspace?id=${draftId}`;
  return <Navigate to={target} replace />;
}
